/*
 *
 * HomePage reducer
 *
 */

import produce from 'immer';
import { ActionTypes } from './actions';

export const key = 'homePage';
export const initialState = {
    page: {
        meta: null,
        destinations: [],
        isLoaded: false,
        isLoading: false,
        isError: false,
        errorMessage: '',
    },
    stories: {
        res: null,
        isLoaded: false,
        isLoading: false,
        isError: false,
        errorMessage: '',
    },
    blogs: {
        res: null,
        isLoaded: false,
        isLoading: false,
        isError: false,
        errorMessage: '',
    },
    promoPrices: {
        values: [],
        isLoading: false,
        isLoaded: false,
        isError: false,
        errorMessage: '',
    },
    popularDestinations: {
        destinations: null,
        isLoading: false,
        isLoaded: false,
        isError: false,
        errorMessage: '',
    },
};

/* eslint-disable no-param-reassign, default-case */
function homePageReducer(state = initialState, action) {
    return produce(state, (draft) => {
        switch (action.type) {
            // Page
            case ActionTypes.FETCH_PAGE_STARTED:
                draft.page.isLoading = true;
                draft.page.isError = false;
                draft.page.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PAGE_SUCCESSFULLY:
                draft.page.isLoading = false;
                draft.page.isLoaded = true;
                draft.page.meta = action.res.meta;
                draft.page.destinations = action.res.destinations;
                return draft;
            case ActionTypes.FETCH_PAGE_FAILED:
                draft.page.isLoading = false;
                draft.page.isError = true;
                draft.page.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PAGE_CANCELLED:
                draft.page.isLoading = false;
                return draft;
            case ActionTypes.SET_PAGE_IS_LOADED:
                draft.page.isLoaded = action.isLoaded;
                return draft;
            // Blogs
            case ActionTypes.FETCH_BLOGS_STARTED:
                draft.blogs.isLoading = true;
                draft.blogs.isError = false;
                draft.blogs.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_BLOGS_SUCCESSFULLY:
                draft.blogs.isLoading = false;
                draft.blogs.isLoaded = true;
                draft.blogs.res = action.res;
                return draft;
            case ActionTypes.FETCH_BLOGS_FAILED:
                draft.blogs.isLoading = false;
                draft.blogs.isError = true;
                draft.blogs.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_BLOGS_CANCELLED:
                draft.blogs.isLoading = false;
                return draft;
            case ActionTypes.SET_BLOGS_IS_LOADED:
                draft.blogs.isLoaded = action.isLoaded;
                return draft;
            // Stories
            case ActionTypes.FETCH_STORIES_STARTED:
                draft.stories.isLoading = true;
                draft.stories.isError = false;
                draft.stories.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_STORIES_SUCCESSFULLY:
                draft.stories.isLoading = false;
                draft.stories.isLoaded = true;
                draft.stories.res = action.res;
                return draft;
            case ActionTypes.FETCH_STORIES_FAILED:
                draft.stories.isLoading = false;
                draft.stories.isError = true;
                draft.stories.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_STORIES_CANCELLED:
                draft.stories.isLoading = false;
                return draft;
            case ActionTypes.SET_STORIES_IS_LOADED:
                draft.stories.isLoaded = action.isLoaded;
                return draft;
            // PromoPrices
            case ActionTypes.RESET_PROMO_PRICES:
                draft.promoPrices.values = [];
                return draft;
            case ActionTypes.FETCH_PROMO_PRICES_STARTED:
                draft.promoPrices.isLoading = true;
                draft.promoPrices.isError = false;
                draft.promoPrices.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_PROMO_PRICES_SUCCESSFULLY:
                draft.promoPrices.isLoading = false;
                draft.promoPrices.isLoaded = true;
                draft.promoPrices.values = action.res;
                return draft;
            case ActionTypes.FETCH_PROMO_PRICES_FAILED:
                draft.promoPrices.isLoading = false;
                draft.promoPrices.isError = true;
                draft.promoPrices.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_PROMO_PRICES_CANCELLED:
                draft.promoPrices.isLoading = false;
                return draft;
            case ActionTypes.SET_PROMO_PRICES_IS_LOADED:
                draft.promoPrices.isLoaded = action.isLoaded;
                return draft;
            // popular destinations
            case ActionTypes.FETCH_POPULAR_DESTINATIONS_STARTED:
                draft.popularDestinations.isLoading = true;
                draft.popularDestinations.isError = false;
                draft.popularDestinations.errorMessage = '';
                return draft;
            case ActionTypes.FETCH_POPULAR_DESTINATIONS_SUCCESSFULLY:
                draft.popularDestinations.isLoading = false;
                draft.popularDestinations.isLoaded = true;
                draft.popularDestinations.destinations = action.destinations;
                return draft;
            case ActionTypes.FETCH_POPULAR_DESTINATIONS_FAILED:
                draft.popularDestinations.isLoading = false;
                draft.popularDestinations.isError = true;
                draft.popularDestinations.errorMessage = action.error.message;
                return draft;
            case ActionTypes.FETCH_POPULAR_DESTINATIONS_CANCELLED:
                draft.popularDestinations.isLoading = false;
                return draft;
            case ActionTypes.SET_POPULAR_DESTINATIONS_IS_LOADED:
                draft.popularDestinations.isLoaded = action.isLoaded;
                return draft;
            default:
                return draft;
        }
    });
}

export default homePageReducer;
